import AttachmentDataProviderItem from 'owa-service/lib/contract/AttachmentDataProviderItem';
import AttachmentDataProviderItemType from 'owa-service/lib/contract/AttachmentDataProviderItemType';
import AttachmentDataProviderType from 'owa-service/lib/contract/AttachmentDataProviderType';
import AttachmentItemsSortColumn from 'owa-service/lib/contract/AttachmentItemsSortColumn';
import AttachmentItemsSortOrder from 'owa-service/lib/contract/AttachmentItemsSortOrder';
import GetAttachmentDataProviderItemsResponse from 'owa-service/lib/contract/GetAttachmentDataProviderItemsResponse';
import handleGetItemsResponse from './handleGetItemsResponse';
import moveFoldersToTheBeginning from './moveFoldersToTheBeginning';
import sortFileProviderItems from './sortFileProviderItems';
import {
    createAttachmentDataProviderItemsResponse,
    createFailedAttachmentDataProviderItemsResponse,
} from './createAttachmentDataProviderItemsResponse';
import {
    DropboxItem,
    getDropboxItems,
    isDropboxDeletedItem,
    isDropboxFileItem,
    isDropboxFolderItem,
} from 'owa-fileprovider-services';
import {
    FileAttachmentDataProviderItemType,
    FolderAttachmentDataProviderItemType,
} from '../constants';

function createAttachmentDataProviderItem(item: DropboxItem): AttachmentDataProviderItem {
    return {
        __type: isDropboxFolderItem(item)
            ? FolderAttachmentDataProviderItemType
            : FileAttachmentDataProviderItemType,
        Id: !isDropboxDeletedItem(item) ? item.id : null,
        AttachmentProviderId: null,
        Location: !isDropboxDeletedItem(item) ? item.path_lower : '',
        Modified: isDropboxFileItem(item) ? item.server_modified : '',
        Name: item.name,
        ProviderType: AttachmentDataProviderType.Dropbox,
        Size: isDropboxFileItem(item) ? item.size : 0,
        Type: isDropboxFolderItem(item)
            ? AttachmentDataProviderItemType.Folder
            : AttachmentDataProviderItemType.File,
    };
}

const createResponseFunc = (items: DropboxItem[]) =>
    createAttachmentDataProviderItemsResponse(items, createAttachmentDataProviderItem);

export default async function getDropboxFileProviderItems(
    location: string,
    sortColumn: AttachmentItemsSortColumn,
    sortOrder: AttachmentItemsSortOrder
): Promise<GetAttachmentDataProviderItemsResponse> {
    const { errorResponse, result } = await getDropboxItems({ path: location });

    if (result) {
        const response = handleGetItemsResponse(
            result,
            null /* errorResponse */,
            createResponseFunc,
            createFailedAttachmentDataProviderItemsResponse
        );

        sortFileProviderItems(response.Items, sortColumn, sortOrder);
        response.Items = moveFoldersToTheBeginning(response.Items);

        return response;
    } else {
        return handleGetItemsResponse(
            null /* result */,
            errorResponse,
            createResponseFunc,
            createFailedAttachmentDataProviderItemsResponse
        );
    }
}
